export default __webpack_public_path__ + "static/media/send-blue.238bbf82.svg";